import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";

const DEFAULT = {
  company_name: "Assistência Técnica",
  cnpj: "",
  address: "",
  phone: "",
  email: "",
  logo_data: "",
  pix_key: "",
  pix_key_type: "email",
  pix_merchant_name: "",
  pix_city: "SAO PAULO",
  warranty_text: "",
  delivery_terms: "",
};

const SettingsContext = createContext({
  settings: DEFAULT,
  loaded: false,
  refresh: () => {},
  save: async () => {},
});

export function SettingsProvider({ children }) {
  const { user } = useAuth();
  const [settings, setSettings] = useState(DEFAULT);
  const [loaded, setLoaded] = useState(false);

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/settings");
      setSettings({ ...DEFAULT, ...data });
      setLoaded(true);
    } catch {
      // ignore
    }
  }, []);

  useEffect(() => {
    if (user) refresh();
    else setLoaded(false);
  }, [user, refresh]);

  const save = async (data) => {
    const { data: saved } = await api.put("/settings", data);
    setSettings({ ...DEFAULT, ...saved });
    return saved;
  };

  return (
    <SettingsContext.Provider value={{ settings, loaded, refresh, save }}>
      {children}
    </SettingsContext.Provider>
  );
}

export const useSettings = () => useContext(SettingsContext);
